import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ERROR_MESSAGE } from '../models/error-messages';

@Pipe({
  name: 'errorMessages',
  standalone: true,
})
export class ErrorMessagesPipe implements PipeTransform {
  transform(errors: ValidationErrors | ValidationErrors[] | null): string[] {
    if (!errors) {
      return [];
    }

    const errorsArray = Array.isArray(errors) ? errors : [errors];

    return errorsArray.flatMap((errObj) =>
      Object.keys(errObj).map((key) => {
        const getMessage = ERROR_MESSAGE[key] || ERROR_MESSAGE['default'];
        const errorValue = errObj[key];
        return getMessage(errorValue);
      }),
    );
  }
}
